import { Checkbox } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { shipment } from '../../../../models/entities/shipment/shipment';

type OwnProps = {
    shipment: shipment;
};

type Props = OwnProps & {
    updateTransportationPaid: (shipmentId: string, transportationPaid: boolean) => Promise<void>;
};

const GreenCheckBoxContainer = styled.div`
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #629e31;
        border-color: #629e31;
    }
`;

const TransportationPaidCellRenderer = ({ shipment, updateTransportationPaid }: Props) => (
    <GreenCheckBoxContainer onClick={(e) => e.stopPropagation()}>
        <Checkbox
            checked={!!shipment.transportationPaid}
            onChange={(e) => {
                void updateTransportationPaid(shipment.id, e.target.checked);
            }}
        />
    </GreenCheckBoxContainer>
);

const mapDispatchToProps = (dispatch: any) => ({
    updateTransportationPaid: (shipmentId: string, transportationPaid: boolean) =>
        dispatch.shipments.updateShipmentTransportationPaid({ shipmentId, transportationPaid })
});

export default connect(null, mapDispatchToProps)(TransportationPaidCellRenderer);
